import { render, staticRenderFns } from "./garden.vue?vue&type=template&id=1844310d&scoped=true"
import script from "./garden.vue?vue&type=script&lang=js"
export * from "./garden.vue?vue&type=script&lang=js"
import style0 from "./garden.vue?vue&type=style&index=0&id=1844310d&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1844310d",
  null
  
)

export default component.exports